define(
	'Tavanoteam.TavanoTeam_SCA_Core_Bug_Fixes_Extension_2020_2.CanonicalTag'
	, ["Facets.Browse.View"]
	, function (FacetsBrowseView) {
		'use strict';
		return {
			loadModule: function loadModule(container) {
                _.extend(FacetsBrowseView.prototype, {
                    getCanonical: function() {
                        var canonical_url = this.getPath();
                        var current_page = this.translator.getOptionValue('page');
                        if (current_page > 1) {
                            canonical_url += '?page=' + current_page;
                        }
                        return canonical_url;
                    }
                });
			}
		};
	}
);
